import React from "react";
import ScrollLayout from "components/ScrollLayout";

const TabGroup = ({children, extClass, inline = true, scroll = false, showNav = false} ) => {

  const layoutClass = scroll
    ? 'flex flex-nowrap overflow-x-auto scrollbar-hide'
    : `${inline ? 'inline-flex' : 'flex'} flex-wrap overflow-hidden`;

  return (
    <div className="overflow-hidden border rounded-md mb-2">
    {scroll ? 
    <ScrollLayout className="!p-0" showNav={showNav}
                      classNav="mx-10 blog-product-nav ml-[112px]" isNavOverlay={true}>{children}</ScrollLayout>
    : <div
      className={`${layoutClass} flex-wrap ${extClass ? ` ${extClass}` : ''}`}>
      {children}
    </div>}
    </div>
  );
};

export const CommonTabGroup = ({children, extClass, aside}) => {
  return (
    <div
      className={`flex space-x-6 items-start w-full justify-between border-b mb-4 ${extClass ? ` ${extClass}` : ''}`}>
      <div className="flex min-w-0">{children}</div>
      {aside}
    </div>
  );
};
export default TabGroup;
